import {addListener} from "@reduxjs/toolkit";
import {QueryStatus} from "@reduxjs/toolkit/query";

import type {IAppDispatch, IRootState} from "../../store/store";
import {getIsUserAuthenticatedApi} from "../../user/api/get_is_user_authenticated";
import {getUserProfileApi, selectUserProfile} from "../../user/api/get_user_profile";
import {IUserProfile} from "../../user/types/IUserProfile";

const addAppListener = addListener.withTypes<IRootState, IAppDispatch>();
const selectAuthStatusQuery = getIsUserAuthenticatedApi.endpoints.getIsUserAuthenticated.select(undefined);

const waitForSettledQuery = <TQueryState extends {status: QueryStatus}>(
    dispatch: IAppDispatch,
    getState: () => IRootState,
    selectQuery: (state: IRootState) => TQueryState
) =>
    new Promise<TQueryState>((resolve) => {
        const isSettled = () => selectQuery(getState()).status !== QueryStatus.pending;

        if (isSettled()) {
            resolve(selectQuery(getState()));
            return;
        }

        dispatch(
            addAppListener({
                predicate: isSettled,
                effect: (_action, listenerApi) => {
                    listenerApi.unsubscribe();
                    resolve(selectQuery(getState()));
                }
            })
        );
    });

/**
 * Profile of the user who has just authenticated, requested once the authentication status written after `authSucceeded`
 * and any profile request started before it have settled. A failed request is retried once. Never rejects: `null` means
 * the session is anonymous or the profile could not be fetched
 */
export const fetchUserProfileAfterAuth =
    () =>
    async (dispatch: IAppDispatch, getState: () => IRootState): Promise<IUserProfile | null> => {
        const readUserProfile = async () => {
            const userProfileQuery = await dispatch(getUserProfileApi.endpoints.getUserProfile.initiate(undefined, {forceRefetch: true, subscribe: false}));

            return userProfileQuery.status === QueryStatus.pending ? waitForSettledQuery(dispatch, getState, selectUserProfile) : userProfileQuery;
        };

        await waitForSettledQuery(dispatch, getState, selectAuthStatusQuery);
        await waitForSettledQuery(dispatch, getState, selectUserProfile);

        const firstAttempt = await readUserProfile();
        const userProfileQuery = firstAttempt.isError ? await readUserProfile() : firstAttempt;

        return userProfileQuery.isSuccess ? (userProfileQuery.data ?? null) : null;
    };
import {addListener} from "@reduxjs/toolkit";
import {QueryStatus} from "@reduxjs/toolkit/query";

import type {IAppDispatch, IRootState} from "../../store/store";
import {getIsUserAuthenticatedApi} from "../../user/api/get_is_user_authenticated";
import {getUserProfileApi, selectUserProfile} from "../../user/api/get_user_profile";
import {IUserProfile} from "../../user/types/IUserProfile";

const addAppListener = addListener.withTypes<IRootState, IAppDispatch>();
const selectAuthStatusQuery = getIsUserAuthenticatedApi.endpoints.getIsUserAuthenticated.select(undefined);

const waitForSettledQuery = <TQueryState extends {status: QueryStatus}>(
    dispatch: IAppDispatch,
    getState: () => IRootState,
    selectQuery: (state: IRootState) => TQueryState
) =>
    new Promise<TQueryState>((resolve) => {
        const isSettled = () => selectQuery(getState()).status !== QueryStatus.pending;

        if (isSettled()) {
            resolve(selectQuery(getState()));
            return;
        }

        dispatch(
            addAppListener({
                predicate: isSettled,
                effect: (_action, listenerApi) => {
                    listenerApi.unsubscribe();
                    resolve(selectQuery(getState()));
                }
            })
        );
    });

/**
 * Profile of the user who has just authenticated, requested once the authentication status written after `authSucceeded`
 * and any profile request started before it have settled. A failed request is retried once. Never rejects: `null` means
 * the session is anonymous or the profile could not be fetched
 */
export const fetchUserProfileAfterAuth =
    () =>
    async (dispatch: IAppDispatch, getState: () => IRootState): Promise<IUserProfile | null> => {
        const readUserProfile = async () => {
            const userProfileQuery = await dispatch(getUserProfileApi.endpoints.getUserProfile.initiate(undefined, {forceRefetch: true, subscribe: false}));

            return userProfileQuery.status === QueryStatus.pending ? waitForSettledQuery(dispatch, getState, selectUserProfile) : userProfileQuery;
        };

        await waitForSettledQuery(dispatch, getState, selectAuthStatusQuery);
        await waitForSettledQuery(dispatch, getState, selectUserProfile);

        const firstAttempt = await readUserProfile();
        const userProfileQuery = firstAttempt.isError ? await readUserProfile() : firstAttempt;

        return userProfileQuery.isSuccess ? (userProfileQuery.data ?? null) : null;
    };
